import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { ConfirmDialogProvider } from './components/Common/ConfirmDialog';
import { ToastProvider } from './components/Common/Toast';
import { LoadingFallback } from './components/Common/LoadingFallback';
import { ChatPage } from './pages/ChatPage';

const AdminPage = React.lazy(() => import('./pages/AdminPage').then((m) => ({ default: m.AdminPage })));
const AIFactoryRoutes = React.lazy(() => import('./pages/AIFactory').then((m) => ({ default: m.AIFactoryRoutes })));
const HistoryPage = React.lazy(() => import('./pages/HistoryPage').then((m) => ({ default: m.HistoryPage })));
const SharedConversationPage = React.lazy(() => import('./pages/SharedConversationPage').then((m) => ({ default: m.SharedConversationPage })));

function AuthenticatedApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<ChatPage />} />
        <Route path="/admin" element={<React.Suspense fallback={<LoadingFallback fullPage />}><AdminPage /></React.Suspense>} />
        <Route path="/history" element={<React.Suspense fallback={<LoadingFallback fullPage />}><HistoryPage /></React.Suspense>} />
        <Route path="/ai-factory/*" element={<React.Suspense fallback={<LoadingFallback fullPage />}><AIFactoryRoutes /></React.Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <ConfirmDialogProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/shared/:token" element={<React.Suspense fallback={<LoadingFallback fullPage />}><SharedConversationPage /></React.Suspense>} />
              <Route path="*" element={<AuthenticatedApp />} />
            </Routes>
          </BrowserRouter>
        </ConfirmDialogProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
